import {
  BRANDS,
  MARKETS,
  POINT_IN_TIME,
  PRE_POST,
  TREND,
  FILTERS,
  SEGMENTS,
  PERIOD_TYPE,
  PERIOD,
  POST_PERIOD_TYPE,
  POST_START_DATE,
  POST_END_DATE,
  STAT_TEST,
  BASE,
  MODE,
  PERIOD_START_DATE,
  PERIOD_END_DATE,
  VISUALIZATION_TYPE,
  AGE_START,
  AGE_END,
  METRIC,
  RESPONSE,
  QUESTION_OPTIONS,
  GROUPED_BY,
  BUTTERLFY,
  SECONDARY_BRANDS,
  DIFFERENTIATION,
  PERCEPTUAL,
  PROFILE,
  SCORE_TYPE,
  PROFILE_GROUP,
  PROFILE_METRIC,
  PROFILE_RESPONSE,
  TRENDS_METRIC,
  TRENDS_RESPONSE,
  VIEW_ID,
  URL_BY_BRAND,
  URL_BY_SEGMENT,
  URL_BY_MARKET,
} from "@/constant/constantsThrougoutProject";
import type { ChildRoute } from "./routes.types";

export const equityBysegment: ChildRoute = {
  id: `equity/${URL_BY_SEGMENT}`,
  redirectTo: `/equity/${URL_BY_SEGMENT}`,
  icon: undefined,
  name: "By Segment",
  useSegmentSelect: true,
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  useSegmentAsFilters: false,
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [PROFILE]: [SEGMENTS],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const equityBybrand: ChildRoute = {
  id: `equity/${URL_BY_BRAND}`,
  redirectTo: `/equity/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, BRANDS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage:
        "Peer-to-Peer comparison is only available for Point in Time analysis.",
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const equityBymarket: ChildRoute = {
  id: `equity/${URL_BY_MARKET}`,
  redirectTo: `/equity/${URL_BY_MARKET}`,
  icon: undefined,
  name: "By Market",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, MARKETS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      METRIC,
      RESPONSE,
      VISUALIZATION_TYPE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      hidden: false,
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      hidden: false,
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const conversionBysegment: ChildRoute = {
  id: `conversion/${URL_BY_SEGMENT}`,
  redirectTo: `/conversion/${URL_BY_SEGMENT}`,
  icon: undefined,
  name: "By Segment",
  useSegmentSelect: true,
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
      VISUALIZATION_TYPE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [PROFILE]: [SEGMENTS],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  //added some base restriction in trend screens level also for conversion
  disableBases: ["AWARE", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const conversionBybrand: ChildRoute = {
  id: `conversion/${URL_BY_BRAND}`,
  redirectTo: `/conversion/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, PROFILE],
  useSegmentAsFilters: true,
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, BRANDS],
    [PRE_POST]: [FILTERS, SEGMENTS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  //added some base restriction in trend screens level also for conversion
  disableBases: ["AWARE", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};
export const conversionBymarket: ChildRoute = {
  id: `conversion/${URL_BY_MARKET}`,
  redirectTo: `/conversion/${URL_BY_MARKET}`,
  icon: undefined,
  name: "By Market",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, MARKETS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  //added some base restriction in trend screens level also for conversion
  disableBases: ["AWARE", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const emotionalBysegment: ChildRoute = {
  id: `emotional/${URL_BY_SEGMENT}`,
  redirectTo: `/emotional/${URL_BY_SEGMENT}`,
  icon: undefined,
  name: "By Segment",
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  useSegmentSelect: true,
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [PROFILE]: [SEGMENTS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
      VISUALIZATION_TYPE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};
export const emotionalBybrand: ChildRoute = {
  id: `emotional/${URL_BY_BRAND}`,
  redirectTo: `/emotional/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [
    TREND,
    POINT_IN_TIME,
    PRE_POST,
    PROFILE,
    DIFFERENTIATION,
    PERCEPTUAL,
    BUTTERLFY,
  ],
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, BRANDS],
    [DIFFERENTIATION]: [FILTERS, SEGMENTS, SECONDARY_BRANDS],
    [PERCEPTUAL]: [FILTERS, SEGMENTS, BRANDS],
    [BUTTERLFY]: [FILTERS, SEGMENTS, SECONDARY_BRANDS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],

    [DIFFERENTIATION]: [
      MARKETS,
      BRANDS,
      SECONDARY_BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
    ],
    [PERCEPTUAL]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
    ],
    [BUTTERLFY]: [
      MARKETS,
      BRANDS,
      SECONDARY_BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};
export const emotionalBymarket: ChildRoute = {
  id: `emotional/${URL_BY_MARKET}`,
  redirectTo: `/emotional/${URL_BY_MARKET}`,
  icon: undefined,
  name: "By Market",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, MARKETS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const advertisingBysegment: ChildRoute = {
  id: `advertising/${URL_BY_SEGMENT}`,
  redirectTo: `/advertising/${URL_BY_SEGMENT}`,
  useSegmentSelect: true,
  icon: undefined,
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [PROFILE]: [SEGMENTS],
  },
  name: "By Segment",
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      min: "2022-09-21",
      max: null,
    },
    [POINT_IN_TIME]: {
      [PROFILE]: {
        "5": {
          min: "2022-09-21",
          max: null,
        },
      },
      min: "2022-09-21",
      max: null,
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};
export const advertisingBybrand: ChildRoute = {
  id: `advertising/${URL_BY_BRAND}`,
  redirectTo: `/advertising/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, PROFILE],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, BRANDS],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      min: "2022-09-21",
      max: null,
    },
    [POINT_IN_TIME]: {
      [PROFILE]: {
        5: {
          min: "2022-09-21",
          max: null,
        },
      },
      min: "2022-09-21",
      max: null,
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};
export const advertisingBymarket: ChildRoute = {
  id: `advertising/${URL_BY_MARKET}`,
  redirectTo: `/advertising/${URL_BY_MARKET}`,
  icon: undefined,
  useSegmentAsFilters: true,
  name: "By Market",
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, MARKETS],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      min: "2022-09-21",
      max: null,
    },
    [POINT_IN_TIME]: {
      min: "2022-09-21",
      max: null,
      [PROFILE]: {
        5: {
          min: "2022-09-21",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};

export const brandVisibilityBysegment: ChildRoute = {
  id: `visibility/${URL_BY_SEGMENT}`,
  redirectTo: `/visibility/${URL_BY_SEGMENT}`,
  useSegmentSelect: true,
  icon: undefined,
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [PROFILE]: [SEGMENTS],
  },
  name: "By Segment",
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      advertisingRecall: {
        min: "2022-09-21",
        max: null,
      },
    },
    [POINT_IN_TIME]: {
      min: "2022-09-21",
      max: null,
      [PROFILE]: {
        8: {
          min: "2022-09-21",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};
export const brandVisibilityBybrand: ChildRoute = {
  id: `visibility/${URL_BY_BRAND}`,
  redirectTo: `/visibility/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, PROFILE],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, BRANDS],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      advertisingRecall: {
        min: "2022-09-21",
        max: null,
      },
    },
    [POINT_IN_TIME]: {
      min: "2022-09-21",
      max: null,
      [PROFILE]: {
        8: {
          min: "2022-09-21",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};
export const brandVisibilityBymarket: ChildRoute = {
  id: `visibility/${URL_BY_MARKET}`,
  redirectTo: `/visibility/${URL_BY_MARKET}`,
  icon: undefined,
  name: "By Market",
  useSegmentAsFilters: true,
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, MARKETS],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      advertisingRecall: {
        min: "2022-09-21",
        max: null,
      },
    },
    [POINT_IN_TIME]: {
      min: "2022-09-21",
      max: null,
      [PROFILE]: {
        8: {
          min: "2022-09-21",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};

export const exclusiveQuestionsBybrand: ChildRoute = {
  id: `exclusivequestions/${URL_BY_BRAND}`,
  redirectTo: `/exclusivequestions/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      VIEW_ID
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      METRIC,
      RESPONSE,
      VIEW_ID
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VISUALIZATION_TYPE,
      VIEW_ID
    ],
  },
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERS, SEGMENTS, QUESTION_OPTIONS],
    [POINT_IN_TIME]: [BRANDS, FILTERS, SEGMENTS, QUESTION_OPTIONS],
    [PRE_POST]: [FILTERS, SEGMENTS, QUESTION_OPTIONS, BRANDS],
  },
  statTestingDetails: {
    PTP: {
      hidden: false,
      enabled: true,
      disabledMessage: null,
      disabledModes: [TREND, PRE_POST],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
        PRE_POST:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
};

export const exclusiveQuestionsBysegment: ChildRoute = {
  id: `exclusivequestions/${URL_BY_SEGMENT}`,
  redirectTo: `/exclusivequestions/${URL_BY_SEGMENT}`,
  useSegmentSelect: true,
  icon: undefined,
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS, QUESTION_OPTIONS],
    [POINT_IN_TIME]: [SEGMENTS, QUESTION_OPTIONS],
    [PRE_POST]: [SEGMENTS, QUESTION_OPTIONS],
  },
  name: "By Segment",
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: false,
      enabled: true,
      disabledMessage: null,
      disabledModes: [TREND, PRE_POST],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
        PRE_POST:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
};

export const reputationBysegment: ChildRoute = {
  id: `reputation/${URL_BY_SEGMENT}`,
  redirectTo: `/reputation/${URL_BY_SEGMENT}`,
  useSegmentSelect: true,
  icon: undefined,
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [PROFILE]: [SEGMENTS],
  },
  name: "By Segment",
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      VIEW_ID,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      SCORE_TYPE,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      METRIC,
      RESPONSE,
      SCORE_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      VISUALIZATION_TYPE,
      SCORE_TYPE,
      VIEW_ID,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      VIEW_ID,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      SCORE_TYPE,
    ],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  //added some base restriction in screens level also for reputation based on scoretype
  disableBases: ["USER", "ADRECALL", "AWARE", "GENPOP", "RQ_GENPOP"],
  defaultBase: ["FAMILIAR"],
  dates: {
    [TREND]: {
      min: "2025-11-17",
      max: null,
    },
    [POINT_IN_TIME]: {
      min: "2025-11-17",
      max: null,
      [PROFILE]: {
        9: {
          min: "2025-11-17",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2025-11-17",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from November 17, 2025.",
};
export const reputationBybrand: ChildRoute = {
  id: `reputation/${URL_BY_BRAND}`,
  redirectTo: `/reputation/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, PROFILE],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      SCORE_TYPE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      METRIC,
      RESPONSE,
      SCORE_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VISUALIZATION_TYPE,
      SCORE_TYPE,
      VIEW_ID,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      SCORE_TYPE,
      VIEW_ID,
    ],
  },
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, BRANDS],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  //added some base restriction in screens level also for reputation based on scoretype
  disableBases: ["USER", "ADRECALL", "AWARE", "GENPOP", "RQ_GENPOP"],
  defaultBase: ["FAMILIAR"],
  dates: {
    [TREND]: {
      min: "2025-11-17",
      max: null,
    },
    [POINT_IN_TIME]: {
      min: "2025-11-17",
      max: null,
      [PROFILE]: {
        "9": {
          min: "2025-11-17",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2025-11-17",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from November 17, 2025.",
};
export const reputationBymarket: ChildRoute = {
  id: `reputation/${URL_BY_MARKET}`,
  redirectTo: `/reputation/${URL_BY_MARKET}`,
  icon: undefined,
  name: "By Market",
  useSegmentAsFilters: true,
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      AGE_START,
      AGE_END,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      TRENDS_RESPONSE,
      SCORE_TYPE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      METRIC,
      RESPONSE,
      SCORE_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      POST_PERIOD_TYPE,
      POST_START_DATE,
      POST_END_DATE,
      AGE_START,
      AGE_END,
      VISUALIZATION_TYPE,
      SCORE_TYPE,
      VIEW_ID,
    ],
    [PROFILE]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      AGE_START,
      AGE_END,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      SCORE_TYPE,
      VIEW_ID,
    ],
  },
  modeOptions: [TREND, POINT_IN_TIME, PROFILE],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERS, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERS, SEGMENTS],
    [PRE_POST]: [FILTERS, SEGMENTS],
    [PROFILE]: [FILTERS, SEGMENTS, MARKETS],
  },
  statTestingDetails: {
    PTP: {
      hidden: true,
      enabled: false,
      disabledMessage: null,
      disabledModes: [TREND],
      disabledModesMessages: {
        TREND:
          "Peer-to-Peer comparison is only available for Point in Time analysis.",
      },
    },
    POP: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [],
    },
    YOY: {
      enabled: true,
      disabledMessage: null,
      disabledModes: [PRE_POST],
      disabledModesMessages: {
        TREND: "Year-over-Year comparison is not available on this screen.",
        PRE_POST: "Year-over-Year comparison is not available on this screen.",
      },
    },
  },
  //added some base restriction in screens level also for reputation based on scoretype
  disableBases: ["USER", "ADRECALL", "AWARE", "GENPOP", "RQ_GENPOP"],
  defaultBase: ["FAMILIAR"],
  dates: {
    [TREND]: {
      min: "2025-11-17",
      max: null,
    },
    [POINT_IN_TIME]: {
      min: "2025-11-17",
      max: null,
      [PROFILE]: {
        "9": {
          min: "2025-11-17",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2025-11-17",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from November 17, 2025.",
};

export const reports: ChildRoute = {
  id: "reports",
  redirectTo: "/reports",
  icon: undefined,
  name: "Reports",
  useSegmentAsFilters: false,
  modeOptions: [],
  urlKeysMapping: {},
  multipleOptionsForKeys: {},
  statTestingDetails: {},
};